import React from 'react';
import Slider from 'react-slick';
import './HomeBlog.css';
import { Link } from 'react-router-dom';
import CustomLink from '../../components/CustomLink/CustomLink';

const HomeBlog = ({ title, link, text, blogs }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
    ],
  };

  return (
    <div className="blog-latest-container">
      <div className="blog-latest-header-container">
        <h1 className="blog-latest-header">{title}</h1>
        <CustomLink link={link} linktext={text} />
      </div>

      <Slider {...settings}>
        {blogs.map((blog, index) => (
          <Link to={`/${link}/${blog._id}`} key={index} className="blog-latest-card-link">
            <div className="blog-latest-card">
              <img src={blog.photo} alt={blog.title} className="blog-latest-photo" />
              <h3 className="blog-latest-title">{blog.title}</h3>
              <p className="blog-latest-details">{blog.details}</p>
            </div>
          </Link>
        ))}
      </Slider>
    </div>
  );
};

export default HomeBlog;
